<template>
	<v-card>
		<v-card-text>
			<diagnostico-nutricional
				:datos="valor.DiagnosticoNutricional"
				@valorCambiado="valorCambiado('DiagnosticoNutricional', $event)"
				:esVisita="true"
			></diagnostico-nutricional>
			<plan-terapeutico-info
				:edad="edad"
				:datos="valor.PlanTerapeutico"
				:validateForm="validar"
				@valorCambiado="valorCambiado('PlanTerapeutico', $event)"
				:esVisita="true"
				:datosAntropometricos="datosAntropometricos"
			></plan-terapeutico-info>
		</v-card-text>
		<v-footer app class="pt-3 d-print-none">
			<v-btn color="secondary" x-large @click.prevent="regresar"
				>Regresar <v-icon>chevron_left</v-icon></v-btn
			>
			<v-spacer></v-spacer>
			<v-btn color="primary" x-large @click.prevent="guardar"
				><v-icon>save</v-icon> Guardar
			</v-btn>
		</v-footer>
	</v-card>
</template>

<script>
import DiagnosticoNutricional from "../historial-clinico/diagnosticoNutricional.vue";
import PlanTerapeuticoInfo from "../historial-clinico/planTerapeuticoInfo.vue";
import ServicioVisita from "../../../services/visita";
export default {
	name: "AnalisisYPlanTerapeutico",
	components: { DiagnosticoNutricional, PlanTerapeuticoInfo },

	data() {
		return {
			valor: {},
			validar: false,
			datosAntropometricos: {},
			edad: 0
		};
	},
	async mounted() {
		this.edad = this.$root.edad;
		await this.obtenerInfoPaso();
	},
	methods: {
		async obtenerInfoPaso() {
			let nombrePaso = "Antroprometria";
			let res = await ServicioVisita.obtenerInfoPaso(
				"Antropometria",
				this.visitaId
			);
			if (res.data.result === 1 && res.data.data.Table0.length) {
				const valor = JSON.parse(res.data.data.Table0[0][nombrePaso]);
				this.datosAntropometricos = valor;
			}
			nombrePaso = "AnalisisPlanTerapeutico";
			const res2 = await ServicioVisita.obtenerInfoPaso(
				nombrePaso,
				this.visitaId
			);
			if (res2.data.result === 1 && res2.data.data.Table0.length) {
				const valor2 = JSON.parse(res2.data.data.Table0[0][nombrePaso]);
				if (valor2) this.valor = valor2;
			}
		},
		regresar() {
			this.$router.back();
		},
		async guardar() {
			this.validar = true;
			this.$nextTick(() => {
				this.$nextTick(async () => {
					if (this.valor.PlanTerapeutico) {
						const res = await ServicioVisita.guardarAnalisisPlanTerapeutico(
							this.visitaId,
							this.valor
						);

						if (res.data.result === 1) {
							this.$router.back();
						} else {
							this.$root.mensajeError = res.data.message;
						}
					} else {
						this.$root.mensajeError =
							"Por favor llene los campos requeridos.";
					}
					this.validar = false;
				});
			});
		},
		valorCambiado(key, valor) {
			this.valor[key] = valor;
		}
	},
	computed: {
		visitaId() {
			return this.$route.params.visitaId;
		}
	}
};
</script>

<style></style>
